import React from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'
import { dateFormate, translations } from '../../utils/constants'

const Datepicker = ({ value, onChange, language }) => {

  const handleChange = (date, dateString) => {
    onChange(date)
  }

  const disabledDate = (current) => {
    return current && current > moment().endOf('day')
  }


  return (
    <DatePicker
      value={value ? moment(value) : null} 
      format={dateFormate}
      disabledDate={disabledDate}
      onChange={handleChange}
      placeholder={translations[language]?.selectDate}
      className='custom-inputs'
      allowClear={false}
    />
  )
}

export default Datepicker
